exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.deliverable-block  .top-row[data-v-79700da5] {\n\tbackground-color:var(--wf-primary);\n\tcolor:var(--wf-secondary);\n}\n.drag-handle[data-v-79700da5] {\n\twidth:2rem;\n}\n", ""]);

// exports
